/*
销售出库
@y=>zqw
*/
import request from '@/utils/request'

//获取其他入库列表
export function getQtrkList(data) {
  return request({
    method: "post",
    url: `/yzdservice/api/enterprise/qtrk/list`,
    data: data
  });
}
//出入库审批枚举
export function crkspEnum() {
  return request({
    method: "get",
    url: `/yzdservice/api/enum/rk/crksp`
  });
}
//新增
export function getckStatusOptions() {
  return request({
    method: "get",
    url: `/yzdservice/api/enum/ck/ty`
  });
}
// 获取入库仓库
export function getckMcOptions(ckId) {
  if(ckId){
    return request({
      method: "get",
      url: `/yzdservice/enterprise/dwCk/getCkxxByCskc/`+ckId
    });
  }else{
    return request({
      method: "get",
      url: `/yzdservice/enterprise/dwCk/getCkxxByCskc`
    });
  }
}
// 新增其他入库（暂时保存）
export function addrkTemp(data) {
  return request({
    method: "post",
    url: `/yzdservice/api/enterprise/qtrk/addTemp`,
    data:data
  });
}
// 新增其他入库(入库)
export function addrk(data) {
  return request({
    method: "post",
    url: `/yzdservice/api/enterprise/qtrk/add`,
    data:data
  });
}
// 删除没有被调用
export function deleteById(id) {
  return request({
    method: "delete",
    url: `/yzdservice/api/enterprise/qtrk/delete/${id}`
  });
}
// 详情
export function detail(id) {
  return request({
    method: "get",
    url: `/yzdservice/api/enterprise/qtrk/detail/${id}`
  });
}
// 打印
export function excelwriter(data) {
  return request({
    method: "post",
    url: "/yzdservice/api/enterprise/qtrk/excelwriter",
    data: data,
    responseType: 'blob'
  });
}
// 修改保存(暂时保存)
export function editByIdTemp(data) {
  return request({
    method: "post",
    url: `/yzdservice/api/enterprise/qtrk/editTemp`,
    data:data
  });
}
// 修改保存(入库)
export function editById(data) {
  return request({
    method: "post",
    url: `/yzdservice/api/enterprise/qtrk/edit`,
    data:data
  });
}
// 变更前校验

export function bgBefore(data) {
  return request({
    method: "post",
    url: `/yzdservice/api/enterprise/qtrk/change`,
    data:data
  });
}
// 最终变更/yzdservice/api/enterprise/qtrk/saveChangeApply
export function bgFinall(data) {
  return request({
    method: "post",
    url: `/yzdservice/api/enterprise/qtrk/saveChangeApply`,
    data:data
  });
}
